import { useExperimentContext } from 'contexts/ExperimentContext';

import { safeFormatAssignmentsForAnalytics } from 'utils/experiments';

/**
 * Hook for getting formatted A/B test data for RAT Analytics
 * Works with server-side experiment assignments
 *
 * @param experimentKeys - Optional array to filter specific experiments for this page
 * @returns Formatted analytics string in pipe-delimited format: "ExperimentKey1:CohortName1|ExperimentKey2:CohortName2"
 */
export const useABTestAnalytics = (experimentKeys?: string[]): string => {
  const { assignments, isReady } = useExperimentContext();

  if (!isReady) {
    return '';
  }

  return safeFormatAssignmentsForAnalytics(assignments, experimentKeys);
};
